import { EMAIL_REGEX, GENERAL_FORM_CONSTANTS } from "../../../../constants";
import { FormValidationType } from "../../../../types";
import { BUSINESS_DETAILS_CONSTANTS } from "../../../constants";

export const formFieldsValidation: FormValidationType = {
  [BUSINESS_DETAILS_CONSTANTS.BUSINESS_UNIT]: {
    required: { value: true },
  },
  [BUSINESS_DETAILS_CONSTANTS.VERTICAL]: {
    required: { value: true },
  },
  [BUSINESS_DETAILS_CONSTANTS.COMPANY_NAME]: {
    required: { value: true },
    maxCharacters: { value: 100 },
  },
  [BUSINESS_DETAILS_CONSTANTS.POINT_OF_CONTACT_DETAILS]: {
    required: { value: false },
  },
  [BUSINESS_DETAILS_CONSTANTS.POINT_OF_CONTACT_NAME]: {
    required: { value: false },
    maxCharacters: { value: 100 },
  },
  [BUSINESS_DETAILS_CONSTANTS.POINT_OF_CONTACT_EMAIL_ADDRESS]: {
    required: { value: false },
    maxCharacters: { value: 150 },
    matchRegExp: {
      value: new RegExp(EMAIL_REGEX),
      message: GENERAL_FORM_CONSTANTS.EMAIL_INVALID_MESSAGE,
    },
  },
  [BUSINESS_DETAILS_CONSTANTS.ADDITIONAL_CONTACT_EMAIL_ADDRESSES]: {
    required: { value: false },
  },
  [BUSINESS_DETAILS_CONSTANTS.ADDITIONAL_CONTACT_EMAIL_ADDRESS_0]: {
    required: { value: false },
    matchRegExp: {
      value: new RegExp(EMAIL_REGEX),
      message: GENERAL_FORM_CONSTANTS.EMAIL_INVALID_MESSAGE,
    },
  },
  [BUSINESS_DETAILS_CONSTANTS.ADDITIONAL_CONTACT_EMAIL_ADDRESS_1]: {
    required: { value: false },
    matchRegExp: {
      value: new RegExp(EMAIL_REGEX),
      message: GENERAL_FORM_CONSTANTS.EMAIL_INVALID_MESSAGE,
    },
  },
  [BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS]: {
    required: { value: false },
  },
  [BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS_LINE_1]: {
    required: { value: true },
  },
  [BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS_LINE_2]: {
    required: { value: false },
  },
  [BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS_CITY]: {
    required: { value: true },
  },
  [BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS_STATE]: {
    required: { value: true },
  },
  [BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS_ZIP_CODE]: {
    required: { value: true },
  },
  [BUSINESS_DETAILS_CONSTANTS.COUNTRY_ID]: {
    required: { value: true },
  },
};
